import httpClient from "./httpClient";

export function updateGrandFinalWeights(payload) {
  return httpClient.put("/exam-config/grand-final-weights", payload).then((res) => res.data);
}
